import Seo from "@/components/site/Seo";

export default function Privacy() {
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="privacy-hero">
        <div className="gp-wrap gp-page-hero__inner">
          <div className="gp-eyebrow">
            <span className="gp-eyebrow-num">07</span>
            <span className="gp-eyebrow-sep" />
            Privacy Notice
          </div>
          <h1 className="gp-h1 gp-page-hero__title">Privacy Notice.</h1>
          <p className="gp-page-hero__lede">
            How Gold Petroleum FZ LLC collects, uses and protects the information you
            share with us. Written in plain English.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="privacy-body">
        <div className="gp-wrap gp-narrow">
          <article className="gp-privacy">
            <h2 className="gp-h3">What we collect</h2>
            <p className="gp-body">
              When you submit our enquiry form we receive the information you enter — your
              name, optional company or organisation, email address, optional phone number,
              enquiry category and the message itself. We also record a hashed version of
              your IP address (never the raw IP), the browser user agent your device sent,
              the referring page, and the timestamp of your submission.
            </p>

            <h2 className="gp-h3">Why we collect it</h2>
            <p className="gp-body">
              To respond to your enquiry and to manage subsequent business correspondence
              with you. That is the only purpose.
            </p>

            <h2 className="gp-h3">Where it's stored</h2>
            <p className="gp-body">
              In a MongoDB database hosted by our platform provider. Access is limited to
              authorised administrators inside Gold Petroleum FZ LLC.
            </p>

            <h2 className="gp-h3">How long we keep it</h2>
            <p className="gp-body">
              Enquiries are retained until the enquiry is resolved and closed, and then
              kept in an internal archive for a reasonable period of business record-keeping.
              The specific retention period is being finalised and will be published here in
              a future update.
            </p>

            <h2 className="gp-h3">Sharing</h2>
            <p className="gp-body">
              We do not sell personal data. We do not share it with third parties except as
              required to operate the site (namely our hosting provider). We do not disclose
              enquiry details to anyone outside Gold Petroleum FZ LLC unless we are legally
              required to.
            </p>

            <h2 className="gp-h3">Cookies</h2>
            <p className="gp-body">
              This site does not currently set analytics or advertising cookies. The only
              browser storage we use is a session token stored locally after an administrator
              signs in to the internal admin area. Visitors to the public website receive no
              tracking cookies from us.
            </p>

            <h2 className="gp-h3">Website Assistant &amp; AI</h2>
            <p className="gp-body">
              The site includes a floating &ldquo;Gold Petroleum Assistant&rdquo; panel that
              can answer general questions about the company, offer curated FAQs, and help
              you submit an enquiry. When the free-text &ldquo;Ask&rdquo; mode is enabled,
              your typed question is sent to a third-party language-model API (Anthropic
              Claude, accessed through Emergent&rsquo;s managed key) so that a grounded
              answer can be generated from public company information only. Questions and
              answers are NOT stored on our servers. Rolling in-memory counters are used
              only to prevent abuse (a maximum of 15 questions per visitor per hour and 60
              per day). We never feed the contents of the enquiry form to the language
              model.
            </p>

            <h2 className="gp-h3">Your rights</h2>
            <p className="gp-body">
              You may request access to, correction of, or deletion of the information you
              have given us by emailing{" "}
              <a
                href="mailto:sales@gpfzllc.com"
                style={{ borderBottom: "1px solid var(--gp-gold)", paddingBottom: 1 }}
              >
                sales@gpfzllc.com
              </a>
              . We will respond within a reasonable time.
            </p>

            <h2 className="gp-h3">Privacy questions</h2>
            <p className="gp-body">
              For any question about how your data is handled, contact{" "}
              <a
                href="mailto:sales@gpfzllc.com"
                style={{ borderBottom: "1px solid var(--gp-gold)", paddingBottom: 1 }}
              >
                sales@gpfzllc.com
              </a>
              .
            </p>

            <hr className="gp-rule" style={{ margin: "48px 0 24px" }} />
            <p className="gp-body gp-mute" data-testid="privacy-under-review">
              Under review — this notice will be updated when the final registered business
              address and any additional data processors are confirmed.
            </p>
          </article>
        </div>
      </section>
    </>
  );
}
